import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import About from "./components/About/About";
import AboutDetail from "./components/AboutDetail/AboutDetail";
import Blog from "./components/Blog/Blog";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import NoMatch from "./components/NoMatch/NoMatch";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/Resume";
import MouseParticles from "react-mouse-particles";
function App() {
  return (
    <Router>
      <Header />   
      <MouseParticles
          g={1}
          color="random"
          cull="MuiSvgIcon-root,MuiButton-root"
          level={6}
        /> 
      <Switch>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/aboutDetail">
          <AboutDetail />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route path="/blog">
          <Blog />
        </Route>
        <Route path="/project">
          <Projects />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch> 
      <Footer />
    </Router>
  );
}

export default App;
